import React from 'react';

function Footer() {
    return (
        <header className='footer-bg'>
            <section className='footer-sec'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-xlg-4 col-lg-4'>
                            <div className='footer-lets'>
                                <h2>Let's talk</h2>
                            </div>
                        </div>
                    </div>
                    <div className='row mb-5'>
                        <div className='col-xlg-2 col-lg-2'>
                            <div className='footer-img'>
                                <img src="assets/images/footer-logo.png" alt="Footer Logo" />
                            </div>
                        </div>
                        <div className='col-xlg-6 col-lg-6'>
                            <div className='footer-content'>
                                <div className='footer-doc-details'>
                                    <h3>Dr.Mahadevan.G.R</h3>
                                    <p>MBBS, MD(General Medicine), IDCCM(lndian Diploma in Critical Care & Medicine)</p>
                                </div>
                                <div className='footer-address'>
                                    <h3>Maya Nursing Home Pvt Ltd, Chennai</h3>
                                    <p>Address: Opp. BSNL Telephone Exchange, 15th Avenue, Ashok Nagar, Chennai - 83</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xlg-4 col-lg-4'>
                            <div className='consultation-details'>
                                <div className='consultation-hours'>
                                    <h3>Consultation Hours:</h3>
                                    <ul className='consultation-hours-sec'>
                                        <li>
                                            <p><strong>Monday - Saturday:</strong> 9AM -1PM </p>
                                        </li>
                                        <li>
                                            <p><strong>Evening:</strong> 5PM - 8PM</p>
                                        </li>
                                        <li>
                                            <p><strong>Sunday:</strong> Emergency Consultations Only</p>
                                        </li>
                                        <li>
                                            <strong>Contact Number:</strong><a href="tel:+91 9940451580">+91 9940451580</a>
                                        </li>
                                        <li>
                                            <strong>Email:</strong> <a href="drgrmaha@gmail.com">drgrmaha@gmail.com</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </header>
    );
}

export default Footer;



